<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CYfNzD/images/9781439664841.jpg?1688985070912" alt="This image is the cover for the book Pawleys Island, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pawleys Island, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The history of Pawleys Island, South Carolina, can be summed up in four words: rice, sea, golf, and hammocks.</b></p><br/><p>The rivers threading through coastal South Carolina created an ideal environment for cultivating rice, and by the mid-18th century, vast plantations were producing profitable crops and wealthy landowners. But those plantations also produced malaria-carrying mosquitoes, so the landowners sent their families to the seashore for the summer and built the first houses on Pawleys Island starting in 1822. The end of slavery doomed the rice culture, and the old plantations were sold to rich Northerners for hunting and fishing retreats. By the 1960s, many of the old plantations were turned into golf courses, reviving the economy. But the beating heart of Pawleys Island remains the rhythm of the sea and what one early visitor called "the only beach in the world."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Roberts, Lee Brockington
      </h2>
      
      <p class="authorDescription body article">Steve Roberts, the author of six books, teaches at George Washington University and has vacationed on Pawleys Island for 40 years. Lee Brockington, an educator and historian at Hobcaw Barony, has coauthored three books on the area.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a9cd37f6